module.exports = __webpack_public_path__ + "files/aa7664d7a488b2eb07af75e96b4097ff.svg";